import { Store, StoreTag } from "./Store";
import User from "./User";
import { FilterBy } from "../features/ManageLead/services";
import TenantBusiness from "./TenantBusiness";
import {
  DateFilterType,
  Survey,
} from "../shared/components/Survey/ReportFilter";
import { SubTag } from "../features/TagsManagement/interfaces/tag";

export type AdditionalField = {
  reportName: string;
  fieldName: string;
  level: string;
};

export type AdditionalFieldProduct = {
  label: string;
  type: string;
  value: string;
};

export enum ReportTypeField {
  TRANSACTION = "transaction",
  ENROLL = "enroll",
}

export const ReportTypeFieldData: Record<ReportTypeField, string> = {
  [ReportTypeField.TRANSACTION]: "All Customers",
  [ReportTypeField.ENROLL]: "New Customers",
};

export enum ReportTypeLoyalty {
  CUSTOMER = "customer",
  STORE = "store",
  OVER_ALL = "overall",
  BILL = "bill",
  SKU = "sku",
  EXPIRY = "expiry",
  MILESTONE = "milestone",
  SCHEME = "scheme",
  SCHEMEMONTH = "schememonth",
}

export const ReportTypeLoyaltyData: Record<ReportTypeLoyalty, string> = {
  [ReportTypeLoyalty.CUSTOMER]: "Customer",
  [ReportTypeLoyalty.STORE]: "Store",
  [ReportTypeLoyalty.OVER_ALL]: "Over All",
  [ReportTypeLoyalty.BILL]: "Bill",
  [ReportTypeLoyalty.SKU]: "SKU",
  [ReportTypeLoyalty.EXPIRY]: "Expiry",
  [ReportTypeLoyalty.MILESTONE]: "Milestone",
  [ReportTypeLoyalty.SCHEME]: "Scheme",
  [ReportTypeLoyalty.SCHEMEMONTH]: "Scheme Monthly Report",
};


export enum StoreHealthTypeKPI {
  ANNUAL = "annual",
  QUARTERLY = "quarterly",
  MONTHLY = "monthly",
  WEEKLY = "weekly",
  DAILY = "daily",
  OVERALL = "overall",
}

export const StoreHealthTypeKPIData: Record<StoreHealthTypeKPI, string> = {
  [StoreHealthTypeKPI.ANNUAL]: "Annual",
  [StoreHealthTypeKPI.QUARTERLY]: "Quarterly",
  [StoreHealthTypeKPI.MONTHLY]: "Monthly",
  [StoreHealthTypeKPI.WEEKLY]: "Weekly",
  [StoreHealthTypeKPI.DAILY]: "Daily",
  [StoreHealthTypeKPI.OVERALL]: "Overall",
};

export enum ReportTypeKPI {
  ANNUAL = "annual",
  DEFAULT = "default",
  QUARTERLY = "quarterly",
  DAILY = "daily",
}

export const ReportTypeKPIData: Record<ReportTypeKPI, string> = {
  [ReportTypeKPI.ANNUAL]: "Annual",
  [ReportTypeKPI.DEFAULT]: "Monthly",
  [ReportTypeKPI.QUARTERLY]: "Quarterly",
  [ReportTypeKPI.DAILY]: "Daily",
};

export enum GroupingColumn {
  RFM = "RFM",
  Tier = "Tier",
}

export const ReportTypeOfferData: Record<GroupingColumn, string> = {
  [GroupingColumn.RFM]: "RFM",
  [GroupingColumn.Tier]: "Tier",
};

export enum ReportTypeVoucher {
  ISSUANCE = "issuance",
  REDEMPTION = "redemption",
  EXPIRY = "expiry",
  UNUSED = "unused",
}

export enum ReportTypeScheme {
  UPLIFT_BY_STORE = "uplift_by_store",
  REGISTER = "register",
  COLLECTIONS = "collections",
  DUES = "dues",
}

export const ReportTypeSchemeData: Record<ReportTypeScheme, string> = {
  [ReportTypeScheme.UPLIFT_BY_STORE]: "Uplift by Store",
  [ReportTypeScheme.REGISTER]: "Scheme Register",
  [ReportTypeScheme.COLLECTIONS]: "Collections",
  [ReportTypeScheme.DUES]: "Dues",
};

export const ReportTypeVoucherData: Record<ReportTypeVoucher, string> = {
  [ReportTypeVoucher.ISSUANCE]: "Issuance",
  [ReportTypeVoucher.REDEMPTION]: "Redemption",
  [ReportTypeVoucher.EXPIRY]: "Expiry",
  [ReportTypeVoucher.UNUSED]: "Unused",
};

export enum GroupingMonth {
  THREE = "3",
  SIX = "6",
  TWELVE = "12",
}

export enum StoreHealthReportTemplateType {
  STORE =  "Store as a row",
  DATE = "Date as a row",
  METRICS = "Metrics as a row",
}

export enum TagBoolean {
  YES = "Yes",
  NO = "No",
}

export enum AdditionalFeaturesType {
  LOYALTY_EARN_BURN = "loyaltyEarnBurn",
  PURCHASE_AND_VISIT_ANALYSIS = "purchaseAndVisitAnalysis",
  MRP_ANALYSIS = "mrpAnalysis",
  HIGHEST_BILL = "highestBill",
  BEST_PRODUCT = "bestProduct",
}
export const AdditionalFeaturesLabelMap: Record<
  AdditionalFeaturesType,
  string
> = {
  [AdditionalFeaturesType.LOYALTY_EARN_BURN]: "Loyalty Earn Burn",
  [AdditionalFeaturesType.PURCHASE_AND_VISIT_ANALYSIS]:
    "Purchase and Visits analysis",
  [AdditionalFeaturesType.MRP_ANALYSIS]: "MRP analysis",
  [AdditionalFeaturesType.HIGHEST_BILL]: "Highest bill details",
  [AdditionalFeaturesType.BEST_PRODUCT]: "Best Product",
};
export interface QuerySegmentType {
  key: string;
  name: string;
}

export interface emailConfig {
  isEmailSyncEnabled: boolean;
  emailIds: string[];
}
export interface BillReport {
  dateFilter?: {
    filterBy?: FilterBy.CREATED_DATE;
    inLastDays?: number;
    startDate?: string;
    endDate?: string;
    filterType?: DateFilterType;
  };
  leadDateFilter?: {
    isFollowUp: boolean;
    startDate: string;
    endDate: string;
    inLastDays: 30;
    filterType: DateFilterType;
  };
  businessId?: number;
  surveys?: Survey[];
  additionalFields?: AdditionalField[];
  productAdditionalFields?: AdditionalFieldProduct[];
  type?: string;
  billCount?: number;
  billValue?: number;
  pointSpend?: number;
  fraudReportType?: string;
  stores?: Store[];
  storeTags?: StoreTag[];
  owners?: User[];
  sources?: string[];
  /** Lead Data Quality Report: remark codes to keep (empty = all leads). */
  remarks?: string[];
  reportType?: ReportTypeField;
  segment?: GroupingColumn;
  monthCount?: GroupingMonth;
  storeHealthReportTemplateType?: StoreHealthReportTemplateType;
  business?: TenantBusiness[];
  querySegment?: QuerySegmentType[];
  date?: string;
  endDate?: string;
  singleStoreTags?: StoreTag[];
  singleStore?: string;
  multiStores?: Store[];
  isUsingTags?: TagBoolean;
  additionalFeatures?: AdditionalFeaturesType[];
  campaignType?: string;
  campaignStatus?: string;
  campaignName?: string;
  emailConfig?: emailConfig;
  channel?: string[];
  groupBySource?: boolean;
  socialCampaignAdSource?: string;
  socialCampaignStatus?: string;
  socialBudgetTypes?: string;
  tags?: SubTag[]
  groups?: string[];
  ticketSources?: string[];
  startDate?: string;
  mobile?: string;
  crossBusiness?: boolean;
}

export interface Pagination {
  page: number;
  rowsPerPage: number;
}

export enum ReportTypes {
  STORE_HEALTH_REPORT = "store_health_report",
  STORE_KPI_REPORT = "store_kpi_report",
  TRANSACTION = "transaction",
  FRAUD_REPORT = "fraud_report",
  MEMBER_BILL_REPORT = "member_bill_report",
  // MEMBER_LOYALTY_REPORT = "member_loyalty_report",
  OVERALL_CAMPAIGN_REPORT = "overall_campaign_report",
  INDIVIDUALIZED_CAMPAIGN_REPORT = "individualized_campaign_report",
  CAMPAIGN_CHANNEL_SPLIT = "campaign_channel_split",
  CAMPAIGN_VARIANT_CHANNEL = "campaign_variant_channel_report",
  TIER_SPLIT_CAMPAIGN_REPORT = "tier_split_campaign_report",
  RFM_SPLIT_CAMPAIGN_REPORT = "rfm_split_campaign_report",
  TIER_SPLIT_VARIANT_REPORT = "tier_split_variant_report",
  RFM_SPLIT_VARIANT_REPORT = "rfm_split_variant_report",
  STORE_STATUS_ACTIVITY = "store_status_activity",
  OVERALL_LEAD_REPORT = "overall_lead_report",
  STORE_CATEGORY_REPORT = "store_category_report",
  STORE_EFFICIENCY_REPORT = "store_efficiency_report",
  STORE_PERSON_EFFICIENCY_REPORT = "store_person_efficiency_report",
  SOURCE_EFFICIENCY_REPORT = "source_efficiency_report",
  PRODUCT_HIERARCHY_EFFICIENCY_REPORT = "product_hierarchy_efficiency_report",
  OFFER_REPORT = "offer_report",
  OFFER_REDEMPTION_REPORT = "offer_redemption_report",
  OFFER_EARN_REPORT = "offer_earn_report",
  VOUCHER_REPORT = "voucher_report",
  SCHEME_REPORT = "scheme_report",
  LIABILITY_SUMMARY_REPORT = "liability_summary_report",
  KPI_REPORT = "kpi_report",
  LEAD_HISTORY_REPORT = "lead_history_report",
  SURVEY_RESPONSE_REPORT = "survey_response_report",
  FRIEND_REFERRAL_REPORT = "friend_referral_report",
  PWA_ENROLMENT_REPORT = "pwa_enrolment_report",
  ECOM_CART_ITEMS_REPORT = "ecom_cart_items_report",
  ECOM_PRODUCT_VIEWS_REPORT = "ecom_product_views_report",
  ECOM_LANDING_EVENTS_REPORT = "ecom_landing_events_report",
  ECOM_SUMMARY_REPORT = "ecom_summary_report",
  LEAD_TELECALL_REPORT = "lead_telecall_report",
  LEAD_DATA_QUALITY_REPORT = "lead_data_quality_report",
  CAMPAIGN_VARIANT_REPORT = "campaign_variant_report",
  SOCIAL_MEDIA_CAMPAIGNS_REPORT = "social_media_campaign_report",
  TICKET_EXPORT = "ticket_export"
}

export enum ReferralDateType {
  REFERRAL_DATE = "referralDate",
  CONVERSION_DATE = "conversionDate",
}

export const ReferralDateTypeData: Record<ReferralDateType, string> = {
  [ReferralDateType.REFERRAL_DATE]: "Referral Date",
  [ReferralDateType.CONVERSION_DATE]: "Conversion Date",
};

export const storeHealthQuerySegmentOptions: Record<string, string> = {
  "CUSTOMER_TYPE" : "Onetimers & Repeaters",
  "AT_RISK_AND_DROPPED_CUSTOMERS" : "At-risk & Dropped Customers",
  "NEW_AND_OLD_CUSTOMERS" : "New & Old Customer Sales",
  "SALES" : "Sales",
};
